import createIcon from '../../createIcon';

/**
 * @component @name RemoveFromQueue
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgM0gzQzEuODkgMyAxIDMuODkgMSA1VjE3QzEgMTguMSAxLjg5IDE5IDMgMTlIOFYyMUgxNlYxOUgyMUMyMi4xIDE5IDIzIDE4LjEgMjMgMTdWNUMyMyAzLjg5IDIyLjEgMyAyMSAzWk0yMSAxN0gzVjVIMjFWMTdaTTE2IDEwVjEySDhWMTBIMTZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RemoveFromQueue = createIcon('RemoveFromQueue', [
  [
    'path',
    {
      d: 'M21 3H3C1.89 3 1 3.89 1 5V17C1 18.1 1.89 19 3 19H8V21H16V19H21C22.1 19 23 18.1 23 17V5C23 3.89 22.1 3 21 3ZM21 17H3V5H21V17ZM16 10V12H8V10H16Z',
      key: 'acgzs1',
    },
  ],
]);

export default RemoveFromQueue;
